import { useAppDispatch, useAppSelector, usePrevious } from '../index';
import { claimParrotTokens, fetchParrotPassTokenClaimStatus, fetchParrotPassesTokenClaimStatus, fetchCurrentCustomer } from '@ogsnetwork/opp-redux-lib';
import { useEffect } from 'react';
export function useClaimParrotTokens() {
    const dispatch = useAppDispatch();
    const passStatus = useAppSelector((state) => state.claimParrotTokens.passStatus);
    const successes = useAppSelector((state) => state.claimParrotTokens.successes);
    const failures = useAppSelector((state) => state.claimParrotTokens.failures);
    const passes = useAppSelector((state) => state.claimParrotTokens.passClaimStatusById);
    const status = useAppSelector((state) => state.claimParrotTokens.status);
    const previousStatus = usePrevious(status);
    function dispatchGetPassTokenClaimStatus(pass) {
        if (typeof pass !== 'undefined') {
            dispatch(fetchParrotPassTokenClaimStatus(pass));
        }
        else {
            dispatch(fetchParrotPassesTokenClaimStatus());
        }
    }
    function dispatchClaimParrotTokens(passes) {
        dispatch(claimParrotTokens(passes));
    }
    useEffect(() => {
        if (status === 'success' && previousStatus === 'claiming') {
            dispatch(fetchCurrentCustomer());
        }
    }, [status]);
    return {
        dispatchGetPassTokenClaimStatus,
        dispatchClaimParrotTokens,
        failures,
        passes,
        passStatus,
        status,
        successes
    };
}
